import * as Sentry from "@sentry/browser";

let integrations = [];

if (+wpData.pageId === 142) {
  integrations.push(
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  );
}
function trackAjaxRequests() {
  const TARGET_URL = "https://homeprime.it/wp-admin/admin-ajax.php";

  // Intercetta fetch()
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [url, options] = args;
    // Filtra: se non è admin-ajax.php → IGNORA
    if (!url.includes(TARGET_URL)) {
      return originalFetch(...args);
    }

    Sentry.addBreadcrumb({
      category: "fetch",
      message: `FETCH → ${url}`,
      level: "info",
      data: { method: options?.method || "GET" },
    });

    try {
      const response = await originalFetch(...args);

      if (!response.ok) {
        Sentry.captureMessage("Fetch error" + response.status, {
          level: "error",
          extra: {
            url,
            status: response.status,
            method: options?.method || "GET",
          },
        });
      }

      return response;
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  // Intercetta XHR
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__sentry_xhr = { method, url };
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const xhr = this;

    xhr.addEventListener("loadend", function () {
      Sentry.addBreadcrumb({
        category: "xhr",
        message: `XHR → ${xhr.__sentry_xhr.url}`,
        level: xhr.status >= 400 ? "error" : "info",
        data: {
          method: xhr.__sentry_xhr.method,
          status: xhr.status,
        },
      });

      if (xhr.status >= 400) {
        Sentry.captureMessage("XHR error", {
          level: "error",
          extra: {
            url: xhr.__sentry_xhr.url,
            status: xhr.status,
            method: xhr.__sentry_xhr.method,
          },
        });
      }
    });

    return originalSend.apply(this, arguments);
  };
}

// Attiva tracciamento AJAX solo nelle pagine con replay
if (+wpData.pageId === 142) {
  trackAjaxRequests();
}
// 🔥 Inizializza Sentry SOLO per questo script
Sentry.init({
  dsn: "https://996e2c63fb1769c1980bff78e50ffe6b@o4510164419084288.ingest.de.sentry.io/4510470585188432",

  // Disattiva TUTTE le catture automatiche
  defaultIntegrations: false,
  autoSessionTracking: false,

  // Attiva SOLO il Replay
  integrations: integrations,

  // Replay al 100% solo qui
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

// 👉 Log manuale
export function sentryLog(message, data = null) {
  Sentry.captureMessage(message, {
    level: "info",
    extra: data,
  });
}

// 👉 Error manuale
export function sentrySendError(error) {
  Sentry.captureException(error);
}

window.sentryLog = function (message, data = null) {
  Sentry.captureMessage(message, { level: "info", extra: data });
};

window.sentrySendError = function (error) {
  Sentry.captureException(error);
};
